import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export default function setQuotationSwiper() {
  const quotationSlider = new Swiper('[data-quotation] .swiper', {
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 1000,
    watchOverflow: true,
    centerInsufficientSlides: true,
    pagination: {
      el: '[data-quotation] .swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: '[data-quotation] .swiper-button-next',
      prevEl: '[data-quotation] .swiper-button-prev',
      disabledClass: '-disabled',
    },
    breakpoints: {
      991: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  });
}
